import React, { Component } from "react";
import { Switch } from "react-router";
import { BusPublicPage } from "../pages/bus-public-page/BusPublicPage";
import { TrainPublicPage } from "../pages/train-public-page/TrainPublicPage";
import { BusLayout } from "./BusLayout";
import { TrainLayout } from "./TrainLayout";
import { RouteWithLayout } from "./RouteWithLayout";

export class BusDefaultSwitch extends Component {
  render() {
    return (
      <Switch>
        {/* <RouteWithLayout layout={BusLayout} exact path="/" component={BusPublicPage} /> */}
        {/* <RouteWithLayout layout={BusLayout} exact path="/public" component={BusPublicPage} /> */}
        {/* <RouteWithLayout layout={TrainLayout} exact path="/trains" component={TrainPublicPage} /> */}
        <RouteWithLayout layout={BusLayout} exact path="/buses" component={BusPublicPage} />
      </Switch>
    );
  }
}
